<template>
    <Breadcrumbs main="Widgets" title="Why Us" />
    <div class="container-fluid">

        <orderChart />

    </div>
</template>
<script lang="ts" setup>
import { defineAsyncComponent } from 'vue';

const orderChart = defineAsyncComponent(() => import("@/components/pages/whyUs/index.vue"))
</script>